// libs
import React, { memo, useEffect } from 'react';

// contexts
import { useDelayedRenderContext } from './DelayedRendererContext';

// defs
interface IDelayedRendererProps {
  children: React.ReactNode;
}

function DelayedRenderer({ children }: IDelayedRendererProps) {
  const { canRenderComponent } = useDelayedRenderContext();
  useEffect(() => {
    if (canRenderComponent) {
      return;
    }

    const handle = window.setTimeout(() => {
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
        console.warn('Delayed Rendered Component not rendered after 1 second - ', children);
      }
    }, 1000);

    return () => {
      window.clearTimeout(handle);
    };
  }, [canRenderComponent, children]);

  if (canRenderComponent === false) {
    return null;
  }

  return <>{children}</>;
}

export default memo(DelayedRenderer);
